import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=6ed69c4e&scoped=true&"
import script from "./specs.vue?vue&type=script&lang=js&"
export * from "./specs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed69c4e",
  null
  
)

export default component.exports